export default __webpack_public_path__ + "static/media/morphys-logo.a2e8d238.webp";